import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faUser, faEye, faChartColumn, faUpload } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../Components/Modal/Modal.jsx";
import Input from "../../Components/Input/Input.jsx";
import { ToastContainer, toast } from "react-toastify";
import Button from "../../Components/Button/Button.jsx";
import "./Dashboard.css";
import Card from "../../Components/Cards/Card";
import Navbar from "../../Components/Navbar/Navbar.jsx";
import ResumesList from "../../Components/ResumeList/ResumeList.jsx";
import { useNavigate } from "react-router-dom";
import { saveResumeTitle, uploadResume } from "../../Api/apiService.js";
import { useSelector } from "react-redux";

function Dashboard() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [titleModal, setTitleModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);
  const [resumeTitle, setResumeTitle] = useState("");
  const [refreshResumeList, setRefreshResumeList] = useState(false);
  const [id, setId] = useState(""); 
  const navigate = useNavigate();

  const userId = useSelector((state) => state.auth);
  console.log(userId);
  const handleResumeClick = () => {
    setTitleModal(true);
  };

  const handleUploadClick = () => {
    setUploadModal(true);
  };

  const handleUploadResume = async (e) => {
    e.preventDefault();
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      toast.error("Please select a file to upload.", {
        autoClose: 2000,
      });
      return;
    }

    const formData = new FormData();
    formData.append("resume", selectedFile);
    formData.append("userId", id);
    formData.append("role", userId.role);
    console.log(formData.get("role"));
    console.log(formData.get("userId"));

    try {
      const response = await uploadResume(formData);

      if (response?.status === 200 || response?.status === 201) {
        toast.success(response?.data?.message || "PDF Resume uploaded successfully!", {
          autoClose: 2000,
        });
        // setRefreshResumeList(!refreshResumeList);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };

  const handleViewResume = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const onCloseTitleModal = () => {
    setTitleModal(false);
  };

  const onCloseUploadModal = () => {
    setUploadModal(false);
  };
console.log(userId.userId);

 

  const handleTitleSave = async () => {
    try {
      const response = await saveResumeTitle(resumeTitle, userId.userId);
      if (response?.status === 200 || response?.status === 201) {
    
        window.localStorage.setItem("profileId", response.data.id);
  
        toast.success(response?.data?.message || "Resume Title Saved", {
          autoClose: 2000,
        });
  
        setTimeout(() => {
          navigate("/personalInfo");
        }, 3000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };

  const handleTitleSaveUpload = async () => {
    try {
      const response = await saveResumeTitle(resumeTitle, userId.userId);
      if (response?.status === 200 || response?.status === 201) {
        
        window.localStorage.setItem("profileId", response.data.id);
        setId(response.data.id);
        console.log(id);

        toast.success(response?.data?.message || "Resume Title Saved", {
          autoClose: 1000,
        });

                setTimeout(() => {
          onCloseUploadModal();
          document.getElementById("resume").click();
          console.log("uploading resume");
        }, 3000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", {
        autoClose: 2000,
      });
    }
  };
  

  const handleProfile = () => {
    navigate("/profile");
  };

  return (
    <div className="dashboard-container-outer">
      <Navbar />
      <div className="dashboard-container">
        <Card icon={<FontAwesomeIcon icon={faFile} />} label="Create Resume" onClick={handleResumeClick} />
        <Card icon={<FontAwesomeIcon icon={faEye} />} label="View Resume" onClick={handleViewResume} />
        {/* <Card icon={<FontAwesomeIcon icon={faChartColumn} />} label="ATS" /> */}
        {/* <Card icon={<FontAwesomeIcon icon={faUpload} />} label="Upload Resume" onClick={() => document.getElementById("resume").click()} /> */}
        <Card icon={<FontAwesomeIcon icon={faUpload} />} label="Upload Resume" onClick={handleUploadClick} />
        <Card icon={<FontAwesomeIcon icon={faUser} />} label="Profile" onClick={handleProfile} />
      </div>

      <input id="resume" type="file" accept="application/pdf" style={{ display: "none" }} onChange={handleUploadResume} />

      <ResumesList isOpen={isModalOpen} onClose={closeModal} onRefresh={() => setRefreshResumeList(!refreshResumeList)}/>
      <Modal show={titleModal} onClose={onCloseTitleModal} height="100px" width="310px">
        <Input
          className="profile-input-field-password"
          type="text"
          label="Enter Resume Title"
          value={resumeTitle}
          onChange={(e) => setResumeTitle(e.target.value)}
        />
        <Button className="change-btn" onClick={handleTitleSave}>
          Save & Next
        </Button>
      </Modal>
      <Modal show={uploadModal} onClose={onCloseUploadModal} height="100px" width="310px">
        <Input
          className="profile-input-field-password"
          type="text"
          label="Enter Resume Title"
          value={resumeTitle}
          onChange={(e) => setResumeTitle(e.target.value)}
        />
        <Button className="change-btn" onClick={handleTitleSaveUpload}>
          Save & Next
        </Button>
      </Modal>
      <ToastContainer />
    </div>
  );
}

export default Dashboard;
